// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-info {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
}

.fund-info__group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.fund-info__separator {
  width: 100%;
  height: 0;
  border-top: 1px dotted var(--border-tertiary);
}

.fund-info__row {
  display: flex;
  align-items: baseline;
  width: 100%;
}

.fund-info__label {
  flex: 1 0 0;
  min-width: 0;
  padding: 4px 16px 4px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-label);
}

.fund-info__value {
  flex-shrink: 0;
  padding: 4px 0 4px 16px;
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  max-width: 50%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 50%;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/FundInfoList/FundInfoList.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B","sourcesContent":[".fund-info {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.fund-info__group {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.fund-info__separator {\n  width: 100%;\n  height: 0;\n  border-top: 1px dotted var(--border-tertiary);\n}\n\n.fund-info__row {\n  display: flex;\n  align-items: baseline;\n  width: 100%;\n}\n\n.fund-info__label {\n  flex: 1 0 0;\n  min-width: 0;\n  padding: 4px 16px 4px 0;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-label);\n}\n\n.fund-info__value {\n  flex-shrink: 0;\n  padding: 4px 0 4px 16px;\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  max-width: 50%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 50%;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
